import React from 'react'
import R from 'ramda'
import PT from 'prop-types'
import Button from '@vimcar/shared-components/components/Button'
import Card from '@vimcar/shared-components/components/Card'
import CardHeader from '@vimcar/shared-components/components/CardHeader'

import i18n from '#utils/i18n'
import styles from './styles.css'

const tp = i18n.prefix('components.CreateBooking')

const AvailableVehiclesList = ({
  availableVehicles,
  className,
  disableAction,
}) => (
  <Card className={className} key='card'>
    <CardHeader
      className={styles.resultsHeader}
      title={tp('results-title')}
      />
    <ul className={styles.results}>
      {R.map((vehicle) => (
        <li className={styles.vehicle} key={vehicle.urn}>
          <p className={styles.vehicleName}>
            {vehicle.name}
          </p>

          <p className={styles.licenseplate}>
            {vehicle.licenseplate}
          </p>

          <p className={styles.makeModel}>
            {vehicle.makeModel}
          </p>

          <div className={styles.vehicleActions}>
            <Button
              raised
              disabled={disableAction}
              onClick={vehicle.handleClickBook}
              >
              {tp('book')}
            </Button>
          </div>
        </li>
      ), availableVehicles)}
    </ul>
  </Card>
)

AvailableVehiclesList.propTypes = {
  availableVehicles: PT.array.isRequired,
  className: PT.string,
  disableAction: PT.bool,
}

export default AvailableVehiclesList
